import { SharedProgrammingService } from './../../common/services/shared-programming.service';
import {Type, OnInit, OnChanges, Component, Input, Output, EventEmitter} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import { ItemsService } from './../../common/services/items.service';
import { ProgrammingEventService } from './../../common/services/event.service';

@Component({
  selector: 'prg-select-trigger',
  providers: [],
  templateUrl: './select-trigger.html',
  styleUrls: [
    './select-trigger.css'
  ]
})
export class SelectTriggerComponent {

  event: Observable<any>;
  categories: Observable<Array<any>>;
  devices: Observable<Array<any>>;
  rooms: Observable<Array<any>>;
  locations: Observable<Array<any>>;
  events: Observable<Array<any>>;

  constructor(
    private store: Store<any>,
    private router: Router,
    private route: ActivatedRoute,
    private eventService: ProgrammingEventService,
    private itemsService: ItemsService,
    private shared: SharedProgrammingService
  ) {
    console.log('select-event: ctor()');
    this.event = this.eventService.event;
    this.events = this.store.select(s => s.programmingEvents.allEvents);

    this.categories = <Observable<Array<any>>>this.store.select(state => state.event.categories);
    this.devices = <Observable<Array<any>>>this.store.select(state => state.event.devices);
    this.rooms = <Observable<Array<any>>>this.store.select(state => state.event.rooms);
  }

  ngOnInit() {
    console.log('select-trigger: oninit');
  }

  private clearCategory() {
    this.eventService.clearCategory();
  }

  private clearDevice() {
    this.eventService.clearDevice();
  }

  private categorySelected(event: any) {
    this.eventService.selectCategory(event.target.value);
  }

  private deviceSelected(event: any) {
    this.eventService.selectDevice(event.target.value);
  }

  private eventSelected(event: any) {
    this.eventService.selectEvent(event).then(
      res => {
        this.router.navigate(['../event'], { relativeTo: this.route });
      }, err => {
        console.error('selevt: error selecting event', err);
      });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-trigger/select-trigger.ts